/**
 * 无人货架介绍页
 * @author PJ
 */
import { Bridge, Log } from '@/utils';
import config from '@/pages/Application/config.js';

import { HeaderBar } from '@/components';

const { share } = config;

export default {
  data() {
    return {
      title: '无人货架“蜂”狂来袭',
    };
  },

  components: {
    HeaderBar,
  },

  methods: {
    onBackEvent() {
      Bridge.invoke('onBack', () => { });
    },

    onShareEvent() {
      this.getUserInfo();

      Bridge.invoke('showShareSheet', (data) => {
        this.shareCb(data);
      }, {
        linkUrl: share.linkUrl,
        title: share.title,
        description: share.desc,
        thumbnailUrl: share.imageWxUrl,
      });
    },

    getUserInfo() {
      Bridge.invoke('getUserInfo', (resData) => {
        this.$store.dispatch('SET_USERINFO', resData);
      }, {});
    },

    onGotoSubmit() {
      Log('app.takeself.h5_application_button');
      this.$router.push({
        path: 'submit',
      });
    },

    shareCb(data) {
      switch (data.status) {
        case 'success':
          this.$router.push({
            path: 'shareSuccess',
          });
          break;
        case 'cancel':
          this.$vux.toast.show({
            position: 'middle',
            type: 'text',
            text: '取消分享',
          });
          break;
        case 'timeout':
        case 'error':
          this.$vux.toast.show({
            position: 'middle',
            type: 'text',
            text: '分享失败',
          });
          break;
        default:
          break;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/Application/components/Introduce/main.js